import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SimplebarAngularModule } from 'simplebar-angular';
import { BurgerButtonWrapperComponent } from '../burger-button-wrapper/burger-button-wrapper.component';
import { NewDocumentViewMenu } from '../components/templates/new-document-view/new-document-view.module';
import { CustomFormFieldsModule } from '../custom-form-fields/custom-form-fields.module';
import { DaveDmsModule } from '../dave-dms-module/dave-dms.module';
import { PreviewModule } from '../dave-dms-module/dave-dms/preview/preview.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { PipesModule } from '../dave-utils-module/dave-shared-components-module/pipes/pipes.module';
import { IconPipeModule } from '../dave-utils-module/icon-pipe/icon-pipe.module';
import { SelectSearchModule } from '../dave-utils-module/select-search/select-search.module';
import { GoToButtonsModule } from '../go-to-buttons/go-to-buttons.module';
import { DocumentEditorDialogComponent } from './components/document-editor-dialog/document-editor-dialog.component';
import { DocumentEditorModule } from './components/document-editor/document-editor.module';
import { DaveDocumentEditorRoutingModule } from './dave-document-editor-routing.module';
import { DaveFullscreenDialogModule } from '../dave-fullscreen-dialog/dave-fullscreen-dialog.module';
// import 'syncfusion-ej-global/i18n/ej.culture.de-DE.min.js';
// import 'syncfusion-ej-global/l10n/ej.localetexts.de-DE.min.js';

@NgModule({
    declarations: [DocumentEditorDialogComponent],
    imports: [
        CommonModule,
        DaveSharedComponentsModule,
        DaveDocumentEditorRoutingModule,
        SimplebarAngularModule,
        FontAwesomeModule,
        MatFormFieldModule,
        MatTooltipModule,
        ReactiveFormsModule,
        MatTableModule,
        MatSelectModule,
        MatOptionModule,
        MatTabsModule,
        RouterModule,
        MatCardModule,
        NewDocumentViewMenu,
        DaveDmsModule,
        AppButtonModule,
        SelectSearchModule,
        MatSortModule,
        IconPipeModule,
        MatListModule,
        PipesModule,
        MatInputModule,
        PreviewModule,
        DocumentEditorModule,
        MatDialogModule,
        DaveLoadingModule,
        CustomFormFieldsModule,
        GoToButtonsModule,
        MatExpansionModule,
        MatMenuModule,
        BurgerButtonWrapperComponent,
        MatDatepickerModule,
        DaveFullscreenDialogModule,
    ],
})
export class DaveDocumentEditorModule {}
